import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRakutenComponent } from './simple-icons-rakuten.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRakutenComponent ],
    exports:      [ SimpleIconsRakutenComponent ],
    bootstrap:    []
})
export class SimpleIconsRakutenModule {}
